import { Home, MessageCircle, CreditCard, User } from "lucide-react";
import { BottomTabBar as SharedBottomTabBar, type TabDefinition } from "@shared/components/BottomTabBar";

const ALL_TABS: TabDefinition[] = [
  { to: "/", label: "Home", icon: Home },
  { to: "/messages", label: "Messages", icon: MessageCircle, tourId: "tab-messages", showUnreadBadge: true },
  { to: "/billing", label: "Billing", icon: CreditCard },
  { to: "/me", label: "Profile", icon: User },
];

type Props = {
  unreadCount?: number;
};

export function BottomTabBar({ unreadCount = 0 }: Props) {
  return <SharedBottomTabBar tabs={ALL_TABS} unreadCount={unreadCount} />;
}
